<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
</style>

<template>
  <div>
    <b-form validated @submit="onSubmit" @reset="onReset">
      <div class="d-flex justify-content-between">
        <h5></h5>
        <div>
          <b-button-group v-if="editableOps">
            <b-button type="submit" variant="outline-primary" size="sm"
              ><span v-if="form.intId === undefined">Save</span><span v-else>Update</span></b-button
            >
            <b-button type="reset" variant="outline-danger" size="sm"
              >Reset</b-button
            >
          </b-button-group>
        </div>
      </div>
    </b-form>
    <br />
    <div class="overflow-auto">
      <div>
        <hr />
        <div class="fixHeightScrollable">
          <h5 align="center">Kick Parameters</h5>
          <hr />
          <b-form-group
            id="input-group-engineer"
            label="Engineer:"
            label-for="input-engineer"
          >
            <b-form-input
              id="input-engineer"
              v-model="form.engineer"
              type="text"
              placeholder="Enter Engineer"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-md"
            label="MD:"
            label-for="input-md"
          >
            <b-form-input
              id="input-md"
              v-model="form.md"
              type="number"
              step="0.001"
              placeholder="Enter MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tvd"
            label="TVD:"
            label-for="input-tvd"
          >
            <b-form-input
              id="input-tvd"
              v-model="form.tvd"
              type="number"
              step="0.001"
              placeholder="Enter TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-bitMd"
            label="Bit MD:"
            label-for="input-bitMd"
          >
            <b-form-input
              id="input-bitMd"
              v-model="form.bitMd"
              type="number"
              step="0.001"
              placeholder="Enter Bit MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-activityDateTime"
            label="Activity date time:"
            label-for="input-activityDateTime"
          >
            <b-form-input
              id="input-activityDateTime"
              v-model="form.activityDateTime"
              type="datetime-local"
              placeholder="Enter Activity date time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-phaseCode"
            label="Phase Code:"
            label-for="input-phaseCode"
          >
            <b-form-select
              id="input-phaseCode"
              v-model="form.phaseCode"
              type="text"
              placeholder="Enter Phase Code"
              :options="comboOptionPhasecode"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-activityCode"
            label="Activity Code:"
            label-for="input-activityCode"
          >
            <b-form-select
              id="input-activityCode"
              v-model="form.activityCode"
              type="text"
              placeholder="Enter Activity Code"
              :options="comboOptionActivitycode"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-subActivityCode"
            label="Sub-Activity Code:"
            label-for="input-subActivityCode"
          >
            <b-form-select
              id="input-subActivityCode"
              v-model="form.subActivityCode"
              type="text"
              placeholder="Enter Sub-Activity Code"
              :options="comboOptionSubactivitycode"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-bhTemp"
            label="BH Temp:"
            label-for="input-bhTemp"
          >
            <b-form-input
              id="input-bhTemp"
              v-model="form.bhTemp"
              type="number"
              step="0.001"
              placeholder="Enter BH Temp"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-kickOccur"
            label="Kick Occur:"
            label-for="input-kickOccur"
          >
            <b-form-select
              id="input-kickOccur"
              v-model="form.kickOccur"
              type="text"
              placeholder="Enter Kick Occur"
              :options="optionsComboKickOccur"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-kickClass"
            label="Kick Class:"
            label-for="input-kickClass"
          >
            <b-form-select
              id="input-kickClass"
              v-model="form.kickClass"
              type="text"
              placeholder="Enter Kick Class"
              :options="optionsComboKickClass"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-kickVolume"
            label="Kick Volume:"
            label-for="input-kickVolume"
          >
            <b-form-input
              id="input-kickVolume"
              v-model="form.kickVolume"
              type="number"
              step="0.001"
              placeholder="Enter Kick Volume"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-holeSize"
            label="Hole Size:"
            label-for="input-holeSize"
          >
            <b-form-select
              id="input-holeSize"
              v-model="form.holeSize"
              type="text"
              placeholder="Enter Hole Size"
              :options="optionsComboHoleSize"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-casingSize"
            label="Casing Size:"
            label-for="input-casingSize"
          >
            <b-form-select
              id="input-casingSize"
              v-model="form.casingSize"
              type="text"
              placeholder="Enter Casing Size"
              :options="optionsComboCasingSize"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-casingShoeMd"
            label="Casing Shoe MD:"
            label-for="input-casingShoeMd"
          >
            <b-form-input
              id="input-casingShoeMd"
              v-model="form.casingShoeMd"
              type="number"
              step="0.001"
              placeholder="Enter Casing Shoe MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-casingShoeTvd"
            label="Casing Shoe TVD:"
            label-for="input-casingShoeTvd"
            :description="'Double (' + $t('unit.ft') + ')'"
          >
            <b-form-input
              id="input-casingShoeTvd"
              v-model="form.casingShoeTvd"
              type="number"
              step="0.001"
              placeholder="Enter Casing Shoe TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-casingBurstPressure"
            label="Casing Burst Pressure:"
            label-for="input-casingBurstPressure"
          >
            <b-form-input
              id="input-casingBurstPressure"
              v-model="form.casingBurstPressure"
              type="number"
              step="0.001"
              placeholder="Enter Casing Burst Pressure"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-casingSafetyFactor"
            label="Casing Safety Factor:"
            label-for="input-casingSafetyFactor"
          >
            <b-form-input
              id="input-casingSafetyFactor"
              v-model="form.casingSafetyFactor"
              type="number"
              step="0.001"
              placeholder="Enter Casing Safety Factor"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-sicp"
            label="SICP:"
            label-for="input-sicp"
          >
            <b-form-input
              id="input-sicp"
              v-model="form.sicp"
              type="number"
              step="0.001"
              placeholder="Enter SICP"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-sidp"
            label="SIDP:"
            label-for="input-sidp"
          >
            <b-form-input
              id="input-sidp"
              v-model="form.sidp"
              type="number"
              step="0.001"
              placeholder="Enter SIDP"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-overkillPressure"
            label="Overkill Pressure:"
            label-for="input-overkillPressure"
          >
            <b-form-input
              id="input-overkillPressure"
              v-model="form.overkillPressure"
              type="number"
              step="0.001"
              placeholder="Enter Overkill Pressure"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tripmargin"
            label="Tripmargin:"
            label-for="input-tripmargin"
          >
            <b-form-input
              id="input-tripmargin"
              v-model="form.tripmargin"
              type="number"
              step="0.001"
              placeholder="Enter Tripmargin"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-mudWeight"
            label="Mud Weight:"
            label-for="input-mudWeight"
          >
            <b-form-input
              id="input-mudWeight"
              v-model="form.mudWeight"
              type="number"
              step="0.001"
              placeholder="Enter Mud Weight"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-formEquivMudWt"
            label="Form Equiv Mud Wt:"
            label-for="input-formEquivMudWt"
          >
            <b-form-input
              id="input-formEquivMudWt"
              v-model="form.formEquivMudWt"
              type="number"
              step="0.001"
              placeholder="Enter Form Equiv Mud Wt"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-porePressure"
            label="Pore Pressure:"
            label-for="input-porePressure"
          >
            <b-form-input
              id="input-porePressure"
              v-model="form.porePressure"
              type="number"
              step="0.001"
              placeholder="Enter Pore Pressure"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-maasp"
            label="MAASP:"
            label-for="input-maasp"
          >
            <b-form-input
              id="input-maasp"
              v-model="form.maasp"
              type="number"
              step="0.001"
              placeholder="Enter MAASP"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-lotEmw"
            label="LOT EMW:"
            label-for="input-lotEmw"
          >
            <b-form-input
              id="input-lotEmw"
              v-model="form.lotEmw"
              type="number"
              step="0.001"
              placeholder="Enter LOT EMW"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <h5 align="center">Weight</h5>
          <hr />
          <b-form-group
            id="input-group-mudTankVolume"
            label="Mud Tank Volume:"
            label-for="input-mudTankVolume"
          >
            <b-form-input
              id="input-mudTankVolume"
              v-model="form.mudTankVolume"
              type="number"
              step="0.001"
              placeholder="Enter Mud Tank Volume"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-weightUpMaterial"
            label="Weight Up Material:"
            label-for="input-weightUpMaterial"
          >
            <b-form-input
              id="input-weightUpMaterial"
              v-model="form.weightUpMaterial"
              type="text"
              placeholder="Enter Weight Up Material"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-weightUpMaterialSg"
            label="Weight Up Material SG:"
            label-for="input-weightUpMaterialSg"
          >
            <b-form-input
              id="input-weightUpMaterialSg"
              v-model="form.weightUpMaterialSg"
              type="number"
              step="0.001"
              placeholder="Enter Weight Up Material SG"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-materialRequiredWtvolflow"
            label="Material required wtvolflow:"
            label-for="input-materialRequiredWtvolflow"
          >
            <b-form-input
              id="input-materialRequiredWtvolflow"
              v-model="form.materialRequiredWtvolflow"
              type="number"
              step="0.001"
              placeholder="Enter Material required wtvolflow"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-materialMixCapacity"
            label="Material mix capacity:"
            label-for="input-materialMixCapacity"
          >
            <b-form-input
              id="input-materialMixCapacity"
              v-model="form.materialMixCapacity"
              type="number"
              step="0.001"
              placeholder="Enter Material mix capacity"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-materialAvailable"
            label="Material Available:"
            label-for="input-materialAvailable"
          >
            <b-form-input
              id="input-materialAvailable"
              v-model="form.materialAvailable"
              type="number"
              step="0.001"
              placeholder="Enter Material Available"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-materialRequiredWtvol"
            label="Material required wtvol:"
            label-for="input-materialRequiredWtvol"
          >
            <b-form-input
              id="input-materialRequiredWtvol"
              v-model="form.materialRequiredWtvol"
              type="number"
              step="0.001"
              placeholder="Enter Material required wtvol"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-materialSackWeight"
            label="Material Sack Weight:"
            label-for="input-materialSackWeight"
          >
            <b-form-input
              id="input-materialSackWeight"
              v-model="form.materialSackWeight"
              type="number"
              step="0.001"
              placeholder="Enter Material Sack Weight"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <h5 align="center">Pump Details</h5>
          <hr />
          <b-form-group
            id="input-group-scr"
            label="SCR:"
            label-for="input-scr"
          >
            <b-form-input
              id="input-scr"
              v-model="form.scr"
              type="number"
              step="0.001"
              placeholder="Enter SCR"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-volumeStroke"
            label="Volume Stroke:"
            label-for="input-volumeStroke"
          >
            <b-form-input
              id="input-volumeStroke"
              v-model="form.volumeStroke"
              type="number"
              step="0.001"
              placeholder="Enter Volume Stroke"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pressureRating"
            label="Pressure Rating:"
            label-for="input-pressureRating"
          >
            <b-form-input
              id="input-pressureRating"
              v-model="form.pressureRating"
              type="number"
              step="0.001"
              placeholder="Enter Pressure Rating"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <h5 align="center">Well Kill</h5>
          <hr />
          <b-form-group
            id="input-group-kickProcedure"
            label="Kick Procedure:"
            label-for="input-kickProcedure"
          >
            <b-form-select
              id="input-kickProcedure"
              v-model="form.kickProcedure"
              type="text"
              placeholder="Enter Kick Procedure"
              :options="optionsComboKickProc"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-killStartDateTime"
            label="Kill start date time:"
            label-for="input-killStartDateTime"
          >
            <b-form-input
              id="input-killStartDateTime"
              v-model="form.killStartDateTime"
              type="datetime-local"
              placeholder="Enter Kill start date time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-killEndDateTime"
            label="Kill end date time:"
            label-for="input-killEndDateTime"
          >
            <b-form-input
              id="input-killEndDateTime"
              v-model="form.killEndDateTime"
              type="datetime-local"
              placeholder="Enter Kill end date time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-initialCasingPressure"
            label="Initial casing pressure:"
            label-for="input-initialCasingPressure"
          >
            <b-form-input
              id="input-initialCasingPressure"
              v-model="form.initialCasingPressure"
              type="number"
              step="0.001"
              placeholder="Enter Initial casing pressure"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-chokePressureMax"
            label="Choke Pressure Max:"
            label-for="input-chokePressureMax"
          >
            <b-form-input
              id="input-chokePressureMax"
              v-model="form.chokePressureMax"
              type="number"
              step="0.001"
              placeholder="Enter Choke Pressure Max"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-finalCasingPressure"
            label="Final Casing Pressure:"
            label-for="input-finalCasingPressure"
          >
            <b-form-input
              id="input-finalCasingPressure"
              v-model="form.finalCasingPressure"
              type="number"
              step="0.001"
              placeholder="Enter Final Casing Pressure"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-totalTime"
            label="Total Time:"
            label-for="input-totalTime"
          >
            <b-form-input
              id="input-totalTime"
              v-model="form.totalTime"
              type="number"
              step="0.001"
              placeholder="Enter Total Time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-killMudWeight"
            label="Kill Mud Weight:"
            label-for="input-killMudWeight"
          >
            <b-form-input
              id="input-killMudWeight"
              v-model="form.killMudWeight"
              type="number"
              step="0.001"
              placeholder="Enter Kill Mud Weight"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <h5 align="center">Remarks</h5>
          <hr />
          <b-form-group
            id="input-group-remarks"
            label="Remarks:"
            label-for="input-remarks"
            style="width: 100%"
          >
            <b-form-textarea
              id="input-remarks"
              v-model="form.remark"
              type="text"
              rows="5"
              placeholder="Enter Remarks"
              :disabled="!editable"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <hr />
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed } from '@state/helpers'
import notify from "devextreme/ui/notify"

Vue.use(VueFormGenerator)

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {type: Number, default: undefined},
    editable: Boolean,
  },
  data() {
    return {
      form: [],
      show: true,
      hasData: false,
      editableOps: this.editable,
      comboOptionPhasecode: [],
      comboOptionActivitycode: [],
      comboOptionSubactivitycode: [],
      optionsComboHoleSize: [],
      optionsComboCasingSize: [],
      optionsComboKickOccur: [],
      optionsComboKickClass: [],
      optionsComboKickProc: [],
    }
  },
  computed: {
    ...formComputed,
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    editable: function (val) {
      this.editableOps = val
    },
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.loadAllCombo()
      this.form = []
      this.getActivityKick({
        params: { submitId: this.submitId },
      }).then((resp) => {
        if (resp.data.data.length > 0) {
          this.hasData = true
          this.form = resp.data.data[0]
        }
        console.log('this.hasData', this.hasData)
      })
    },
    loadAllCombo() {
      this.loadComboPhaseCode()
      this.loadComboActivityCode()
      this.loadComboSubactivityCode()
      this.loadComboHoleSize()
      this.loadComboCasingSize()
      this.loadComboKickProc()
      this.loadComboKickClass()
      this.loadComboKickOccur()
    },
    loadComboKickProc() {
      this.getComboListKickProc({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboKickProc = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboKickProc.push(_temp)
        }
      })
    },
    loadComboKickClass() {
      this.getComboListKickClass({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboKickClass = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboKickClass.push(_temp)
        }
      })
    },
    loadComboKickOccur() {
      this.getComboListKickOccur({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboKickOccur = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboKickOccur.push(_temp)
        }
      })
    },
    convertNomSize(nom) {
      if (!isNaN(nom)) return nom
      let sizeStrings = nom.split(" ")
      let sizeValue = parseFloat(sizeStrings[0])
      if (sizeStrings.length > 1) {
        let element = sizeStrings[1].split("/")
        let elementsValue = parseFloat(element[0]) / parseFloat(element[1])
        sizeValue += elementsValue
      }
      return sizeValue
    },
    loadComboHoleSize() {
      this.getComboListWorkstringSize({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        _arrData.sort((x,y)=>this.convertNomSize(x.comboValue)-this.convertNomSize(y.comboValue))
        this.optionsComboHoleSize = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboHoleSize.push(_temp)
        }
      })
    },
    loadComboCasingSize() {
      this.getComboListCasingSize({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboCasingSize = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboCasingSize.push(_temp)
        }
      })
    },
    loadComboSubactivityCode() {
      this.getComboOptionSubactivitycode({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.comboOptionSubactivitycode = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.comboOptionSubactivitycode.push(_temp)
        }
      })
    },
    loadComboActivityCode() {
      this.getComboOptionActivitycode({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.comboOptionActivitycode = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.comboOptionActivitycode.push(_temp)
        }
      })
    },
    loadComboPhaseCode() {
      this.getComboOptionPhasecode({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.comboOptionPhasecode = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.comboOptionPhasecode.push(_temp)
        }
      })
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    onSubmit(evt) {
      evt.preventDefault()

      if (this.hasData) {
        // if intId is exist that means data has already at server
        // time to update
        const data = { ...this.form }
        this.updateActivityKick({ params: data }).then((resp) => {
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      } else {
        // time to insert
        const data = { ...this.form, submitId: this.submitId }
        this.addActivityKick({ params: data }).then((resp) => {
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      this.form = []
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>